import { render, staticRenderFns } from "./risk-first-mortgage.vue?vue&type=template&id=19cb20cd&scoped=true&"
import script from "./risk-first-mortgage.vue?vue&type=script&lang=js&"
export * from "./risk-first-mortgage.vue?vue&type=script&lang=js&"
import style0 from "./risk-first-mortgage.vue?vue&type=style&index=0&id=19cb20cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cb20cd",
  null
  
)

export default component.exports